import * as App from '@/api/app'
import Cookies from 'js-cookie'


export default {
  state:{
    token:Cookies.get('Admin-Token'),
    loginFlag:false,
    user:null
  },
  getters:{},
  mutations:{
    SET_TOKEN:(state, token)=>{
      state.token = token;
    },
    SET_USER:(state, user)=>{
      state.user = user;
    },
  },
  actions:{
    Login: async({commit},data)=>{
      let res = await App.login(data)
      Cookies.set('Admin-Token', 1);
      commit('SET_TOKEN', 1);
      return res
    },
    Logout: async({commit},data)=>{
      let res = await App.logout(data)
      commit('SET_USER',null);
      Cookies.remove('Admin-Token');
      commit('SET_TOKEN', 0);
      return res
    },
    GetuserInfo:async({commit})=>{
      let res = await App.getUserInfo()
      commit('SET_USER',res)
      return res
    }
  }
}